import React, { FC, useCallback } from 'react'
import { Grid } from '@mui/material'
import { FormProvider, useForm } from 'react-hook-form'
import { IWallet, CreateUserWalletRequestDto } from '@sparling/financial-common'
import { useDispatch } from 'react-redux'
import { classValidatorResolver } from '@hookform/resolvers/class-validator'
import { InputSelect } from '../../../../../../../components/Dashboard/InputSelect'
import { createEnum } from '../../../../../../../utils/createEnum'
import { InputField } from '../../../../../../../components/Dashboard/InputField'
import { Modal } from '../../../../../../../components/Dashboard/Modal'
import { createUserWalletRequest } from '../../../../../../../store/actions'

interface Props {
  isOpen: boolean
  isSubmit: boolean
  modalClose: () => void
  currencies: string[]
}

export const WalletsModal: FC<Props> = ({ isOpen, isSubmit, modalClose, currencies }) => {
  const dispatch = useDispatch()

  const formMethods = useForm<IWallet>({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: classValidatorResolver(CreateUserWalletRequestDto),
  })

  const {
    handleSubmit,
    formState: { isValid },
    reset,
  } = formMethods

  const formSubmitHandle = useCallback(
    (data: IWallet) => {
      dispatch(createUserWalletRequest(data))
      reset()
      modalClose?.()
    },
    [dispatch, modalClose, reset],
  )

  return (
    <Modal
      title={'Add Wallet'}
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={handleSubmit(formSubmitHandle)}
      onCancel={modalClose}
      submitTitle={'Submit'}
      cancelTitle={'Close'}
      isSubmit={isSubmit}
      isSubmitDisabled={!isValid}
      width={680}
      submitButtonProps={{
        type: 'button',
      }}
    >
      <FormProvider {...formMethods}>
        <Grid container spacing={2.5}>
          <Grid item xs={12} sm={12} container direction="column">
            <InputSelect
              key="currency"
              labelName="Currency"
              inputName="currency"
              placeholder="Please Select"
              enums={createEnum(currencies)}
              width={'100%'}
              mb={20}
              defaultValue={currencies[0] || ''}
            />
            <InputField
              key="address"
              labelName="Address"
              inputName="address"
              inputType="text"
              width={'100%'}
              marginBottom={20}
            />
            <InputField
              key="addressSuffix"
              labelName="Address Suffix"
              inputName="addressSuffix"
              inputType="text"
              width={'100%'}
              marginBottom={20}
            />
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}
